import { axios } from '../../services/axios';

const getWebexServiceProfile = async ({ scope }) => {
    const result = await axios.get(`/ServiceProfile/Webex/${scope}`);
    return result;
};
export default getWebexServiceProfile;
